/* card-variant-bridge.js
   FASE 6.4 (18/mai/2026)

   Ponte bidirecional entre o <select.card-variant-select> nativo
   (visível em mobile ≤768px) e os <input type="radio"> escondidos
   no .option-selector__btns (que continuam sendo source-of-truth
   para variant-picker.js, loop-mini.js, card-unit-price.js,
   atc-hardened.js, add-to-cart-form.js).

   Por que bridge ao invés de substituir os radios:
   - variant-picker.js já escuta change nos inputs[type=radio]
   - Toda a infra (sub-price refresh, ATC price, per-unit) já funciona
   - Risco zero: se o JS falhar, em desktop os chips continuam funcionando
     normalmente; em mobile o <select> apenas não sincroniza (radio
     ainda recebe submit via form quando ATC for clicado, porque o
     radio default `checked` permanece marcado).

   Event delegation: 1 listener no document cobre todos os cards
   presentes e futuros (Section Rendering API safe).
*/
(function () {
  if (window.__CARD_VARIANT_BRIDGE_INITED__) return;
  window.__CARD_VARIANT_BRIDGE_INITED__ = true;

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    // ---- 1. <select> mudou → CLICA no <label> correspondente ----
    // Iteração 2 (19/mai/2026): em vez de marcar radio + dispatch programático
    // (que pode não disparar todos os listeners corretamente em alguns paths),
    // simula o click no <label for="..."> — caminho idêntico ao desktop chip.
    // O label nativamente marca o radio + dispara click + change + bubble.
    if (t.matches && t.matches('select.js-variant-select')) {
      var opt = t.options[t.selectedIndex];
      if (!opt) return;
      var fieldset = t.closest('.option-selector');
      if (!fieldset) return;

      // Acha o radio local por value (não getElementById que pode colidir)
      var safeVal = (window.CSS && CSS.escape) ? CSS.escape(opt.value) : opt.value.replace(/"/g, '\\"');
      var radio = fieldset.querySelector('input[type="radio"].js-option[value="' + safeVal + '"]');
      if (!radio) return;

      // Acha o <label for="X"> que controla esse radio
      var radioId = radio.id;
      var label = radioId ? fieldset.querySelector('label[for="' + radioId + '"]') : null;
      if (label) {
        label.click(); // user-agent: marca radio, dispara change + click + bubble naturalmente
      } else {
        // Fallback: marcar manualmente
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // ---- 2. Radio mudou → sincroniza o <select> (caso resize de viewport
    //         ou seleção via desktop chips que migrou para mobile no scroll) ----
    if (t.matches && t.matches('input[type="radio"].opt-btn.js-option')) {
      // Procura o <select> irmão dentro do mesmo .option-selector
      var fieldset = t.closest('.option-selector');
      if (!fieldset) return;
      var sel = fieldset.querySelector('select.js-variant-select');
      if (!sel) return;
      if (sel.value !== t.value) {
        sel.value = t.value;
      }
    }
  });
})();
